import { render, staticRenderFns } from "./HealthOk.vue?vue&type=template&id=130e4a66&"
import script from "./HealthOk.vue?vue&type=script&lang=js&"
export * from "./HealthOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130e4a66')) {
      api.createRecord('130e4a66', component.options)
    } else {
      api.reload('130e4a66', component.options)
    }
    module.hot.accept("./HealthOk.vue?vue&type=template&id=130e4a66&", function () {
      api.rerender('130e4a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/HealthOk.vue"
export default component.exports